import { GEO_DATA_SUCCESS } from '../actions/geoDataActions';


export const geoData = (state = {}, action) => {
  switch (action.type) {
    case GEO_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.dataset]: action.payload.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/geoDataReducer.js